{
    "UserRoleLabel": "Role:",
    "RoleCustomLabel": "Custom",
    "RoleRequiresReportingLevel": "Users role requires reporting access",
    "RoleRequiresNoReportingLevel": "Users role requires no reporting access",
    "RolePermissionsTooLow": "You do not have permissions high enough to edit this user. Please speak to an administrator to increase your permissions to allow you to edit this user.",
    "RoleReportingGroup": "REPORTING ROLES",
    "RoleAdminGroup": "ADMINISTRATOR ROLES",
    "UserCustomizedRoles": "CUSTOM ROLE TEMPLATES",
    "CreateCustomRole": "Add custom role template",
    "DeleteCustomRole": "Delete custom role template",
    "NONE": "[None]",
    "REPORTING_USER": "Reporting Only User",
    "ADVANCED_REPORTING_USER": "Advanced Reporting User",
    "END_USER_ADMIN": "End User Only",
    "CUSTOM": "Custom",
    "SUPER_ADMIN": "Full Admin",
    "RESELLER_ADMIN": "Reseller",
    "TELEPHONY_SERVER_ADMIN": "Reseller - SP",
    "PARTITION_ADMIN": "Reseller - Site",
    "SUPPORT": "Support",
    "VIEW": "Full Admin (Read Only)",
    "BILLING_SUPPORT": "Billing",
    "END_USER_PROVISIONING": "Provisioning",
    "SELF_PROVISIONER": "Enterprise Provisioning",
    "USER_MANAGER": "User Manager",
    "Role:NONE": "No role is assigned, this user will have the default permissions",
    "Role:REPORTING_USER": "A role with reporting access level and default permissions",
    "Role:ADVANCED_REPORTING_USER": "Supervisor with reporting access and some advanced administrator actions",
    "Role:END_USER_ADMIN": "Administrator with advanced actions only and no reporting access",
    "Role:CUSTOM": "A customised role with permissions assigned as needed",
    "Role:SUPER_ADMIN": "Administrator with full administrator rights (and can have optional reporting access)",
    "Role:RESELLER_ADMIN": "Administrator with full administrator rights except for changing licence level (and can have optional reporting access)",
    "Role:TELEPHONY_SERVER_ADMIN": "Administrator with full administrator rights up to Telephony Level (and can have optional reporting access)",
    "Role:PARTITION_ADMIN": "Administrator with full administrator rights up to Partition Level (and can have optional reporting access)",
    "Role:SUPPORT": "Administrator with technical administrator rights and (and can have optional reporting access)",
    "Role:VIEW": "Administrator who can view only (and can have optional reporting access)",
    "Role:BILLING_SUPPORT": "Administrator with view only access but has the ability to download CDR's and see audit logs (and can have optional reporting access)",
    "Role:END_USER_PROVISIONING": "Administrator with ability to provision by adding and modifying only (and can have optional reporting access)",
    "Role:SELF_PROVISIONER": "Administrator with ability to provision using the provisioning wizard (and can have optional reporting access)",
    "Role:USER_MANAGER": "For managing users through the User Management popup.",
    "Role:TEAMS_PROVISIONING": "Administrator with ability to authorise and manage Telephony servers",
    "NAME": "RoleLanguage"
}